module.exports = __webpack_public_path__ + "assets/GoodsDG.ad11edf6.svg";